export default __webpack_public_path__ + "locales/fr/Common.json?hash=b607e2c128b8f332226b8989d6f19a12";